// extracted by mini-css-extract-plugin
export default {"mdBreak":"1024px","currencyDropdown":"lkdISDjQfg1e4ve_CyHi","generalDetails":"UtVpZ0xnaOcd7eGSys1m"};